import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const PREFIX = 'AuthButton';

const classes = {
  containedPrimary: `${PREFIX}-containedPrimary`,
  containedSecondary: `${PREFIX}-containedSecondary`,
};

const Btn = (props) => (
  <Button
    disableElevation={false}
    disableRipple={false}
    disableFocusRipple={false}
    disableTouchRipple={false}
    {...props}
  />
);

const StyledButton = styled(Btn)(({ theme }) => ({
  [`& .${classes.containedPrimary}`]: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
  },

  [`& .${classes.containedSecondary}`]: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.contrastText,
    },
  },
}));

export default StyledButton;
